<div class="text-center">
  <div class="kt-spinner kt-spinner--v2 kt-spinner--danger rek-spinner"></div>
  <p class="kt-mt-20" *ngIf="text">
    {{ text }}
  </p>
</div>